import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, switchMap, filter, take, tap } from 'rxjs/operators';
import { AuthTokenService } from '../services/auth-services/auth-token.service';
import { SharedService } from '../services/shared/shared.service';

let isRefreshing = false;
const refreshTokenSubject = new BehaviorSubject<any>(null);

export const apiInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthTokenService);
  const sharedService = inject(SharedService);

  showLoader(sharedService);

  const token = localStorage.getItem('token') || authService.getToken();
  if (token) {
    request = addTokenToRequest(request, token);
  }

  return next(request).pipe(
    tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        hideLoader(sharedService);
      }
    }),
    catchError((error: any) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        if (!isRefreshing) {
          isRefreshing = true;
          refreshTokenSubject.next(null);

          return authService.refreshToken().pipe(
            switchMap((newToken: string) => {
              isRefreshing = false;
              refreshTokenSubject.next(newToken);
              request = addTokenToRequest(request, newToken);
              return next(request);
            }),
            catchError((refreshError: any) => {
              isRefreshing = false;
              return throwError(() => refreshError);
            })
          );
        } else {
          return refreshTokenSubject.pipe(
            filter((token) => token !== null),
            take(1),
            switchMap(() => {
              request = addTokenToRequest(request, authService.getToken());
              return next(request);
            })
          );
        }
      } else {
        hideLoader(sharedService);
        return throwError(() => error);
      }
    })
  );
};

function addTokenToRequest(request: HttpRequest<any>, token: any) {
  return request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
}

function showLoader(sharedService: SharedService) {
  sharedService.showHideSpinner(true);
}

function hideLoader(sharedService: SharedService) {
  sharedService.showHideSpinner(false);
}
